import type { ViewEntity } from '@view-model/domain/view';
import type { ViewModelEntity } from '@view-model/domain/view-model';
import { Link } from 'react-router-dom';
import { UserPagePathBuilder } from '@user/pages/UserPagePathBuilder';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWindowMaximize } from '@fortawesome/free-regular-svg-icons';
import { faLock } from '@fortawesome/free-solid-svg-icons';
import { VIEW_TITLE_PLACE_HOLDER } from '@view-model/ui/components/View/ViewTitleInput';
import { classNames } from '@framework/utils';
import { HighlightText } from './HighlightText';

type Props = {
  view: ViewEntity;
  viewModel: ViewModelEntity;
  searchKeyword?: string;
  isExternal?: boolean;
};

export const ViewItemTitle: React.FC<Props> = ({ view, viewModel, searchKeyword, isExternal = false }: Props) => {
  return (
    <Link
      to={`${UserPagePathBuilder.viewModelPage(viewModel.id)}?targetView=${view.id}`}
      className={classNames('flex min-w-0 items-center rounded-sm py-1 pr-1')}
      {...(isExternal && { target: '_blank', rel: 'noopener noreferrer' })}
    >
      <span className="fa-layers fa-fw mr-1 shrink-0 text-brand">
        <FontAwesomeIcon icon={faWindowMaximize} />
      </span>
      {view.setting.isLocked && (
        <span className="fa-layers fa-fw mr-1 shrink-0 text-brand">
          <FontAwesomeIcon icon={faLock} />
        </span>
      )}
      <HighlightText
        className="truncate"
        text={view.name.value || VIEW_TITLE_PLACE_HOLDER}
        keyword={searchKeyword || ''}
      />
    </Link>
  );
};
